var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.property)?_c('property-editor',{attrs:{"user":_vm.user,"property":_vm.property}}):(_vm.notFound)?_c('div',[_vm._v(" not found! ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }